import type { SelectFieldProps } from "../types/layout.js";

export function SelectField({
  label,
  controlId,
  className = "",
  children,
  value,
  ...props
}: SelectFieldProps) {
  const empty = value === undefined || value === null || value === "";
  return (
    <label className={`block min-w-0 text-sm font-medium ${className}`}>
      <span className="mb-2 block text-secondary-text">{label}</span>
      <select
        className={`min-h-11 w-full max-w-full rounded-xl border border-input bg-background px-3 py-2 font-normal shadow-xs focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring/30 ${
          empty ? "text-disabled" : "text-foreground"
        }`}
        data-control-id={controlId}
        value={value}
        {...props}
      >
        {children}
      </select>
    </label>
  );
}
